export default __webpack_public_path__ + "media/transfer_window/transfer_password-cc55b0f5.gif";